import React from 'react';

export const funcionContext = React.createContext(
    ''// valor por defecto
);